export const processes = {
  name: "Name",
  deleteConfirm: 'Prozess "{process}" löschen ?',
  deleteConfirmText:
    'Möchten Sie den Prozess "{process}" wirklich löschen? Sie können dies nach dem Löschen nicht wiederherstellen.'
};
